import axios from 'axios'
import globalConfig from './globalConfig'
import {get_current_timestamp} from '../helper/helper';
const GET_REQUEST = 'get'
const POST_REQUEST = 'post'
const dataServer1Url = `http://127.0.0.1:${globalConfig.backendPort}/api`
const dataServer2Url = "https://commonsensevis-backend.vercel.app"
// 'http://commonsenseb.s20.hkustvis.org/api'
const dataServerUrl = dataServer2Url;
const dataLocalServerUrl = window.location.origin + "/data";
const ENABLE_STATIC_JSON = false;
// true;

// for user study
var USERID = "test1";
var USERNAME = "test1_name";
var USERSTUDY_MODE = globalConfig.USERSTUDY_MODE;
function updateUserInfo(userid, username){
    USERID = userid;
    USERNAME = username;
    console.log("USERID, USERNAME", USERID, USERNAME);
    console.log("get_current_timestamp", get_current_timestamp());

    // login event
    let target_info = {"view":"user_study_modal", "target":"form"}
    saveUserDataWrapper("login", target_info, {})

}
function request(url, params, type, callback) {
    let func
    if (type === GET_REQUEST) {
        func = axios.get
    } else if (type === POST_REQUEST) {
        func = axios.post
    }

    func(url, params).then((response) => {
            if (response.status === 200) {
                callback(response["data"])
            } else {
                console.error(response) /* eslint-disable-line */
            }
        })
        .catch((error) => {
            console.error(error) /* eslint-disable-line */
        })
}

function intialize(dataset, split, callback) {
    // console.log("dataset: ", dataset);
    let url = `${dataServerUrl}/init/${dataset}/${split}`
    if(ENABLE_STATIC_JSON){
        url = `${dataLocalServerUrl}/init_${dataset}_${split}.json`
    }
    const params = {}
    request(url, params, GET_REQUEST, callback)
}


// function queryPattern(patternStr, idListStr, callback) {
//     let url = `${dataServerUrl}/pattern_search/${patternStr}/${idListStr}`
//     const params = {}
//     request(url, params, GET_REQUEST, callback)
// }

function searchPattern(dataset, split, patternStr, idListStr, callback) {
    let url = `${dataServerUrl}/pattern_search/${dataset}/${split}`
    const params = {
        'query_pattern': patternStr, 
        'id_list': idListStr, 
    }
    request(url, params, POST_REQUEST, callback)
}

// Perform subgroup clustering. 
function subgroupCluster(dataset, split, idList, cNum, cType, callback) {
    let url = `${dataServerUrl}/subgroup_cluster/${dataset}/${split}`
    const params = {
        'cluster_type': cType, 
        'cluster_num': cNum, 
        'lassoed_id_list': idList,
    }
    request(url, params, POST_REQUEST, callback)
}


// qcPairs: {edit_query: [{question: '', choices: [], target: '' },... ]}
function editModelQA(editQuery, callback){
    let url = `${dataServerUrl}/model/qa/edit`;
    const params = editQuery;
    request(url, params, POST_REQUEST, callback);
}

// qcPairs: {editQuery: "", choices: ["", ]}
function runModelQA(qcPairs, callback){
    let url = `${dataServerUrl}/model/qa`;
    const params = qcPairs;
    request(url, params, POST_REQUEST, callback);
}


// Query choices's one hops within stem tokens and qc
function choicesOneHops(qid, callback) {
    let url = `${dataServerUrl}/cpnet/choices_one_hops`;
    const params = {
        "question_id": qid, 
    }
    request(url, params, POST_REQUEST, callback)
}

function saveUserData(userid, username, userjson, callback){
    let url = `${dataServerUrl}/save_user_data/${userid}/${username}`;
    const params = userjson
    request(url, params, POST_REQUEST, callback)
}

function saveUserDataWrapper(event, target_info, additional_info){
    // userjson
    // "event": "click", "login", "hover", "select"
    // "targetinfo": {"view", "target"}
    // "timestamp"
    // "additional_info": {"relation", "projection_mode", "color_mode", ""}


    // "view": "global_view", "subset_view", "instance_view"
    // "target": 
        // global_view: "zoom", "lasso", "reset", "relation_bars", "projection_mode", "color_mode"
        // subset_view: "cluster_num", "cluster_glyphs"
        // instance_view: "accuracy_bars", "avg_qc_hit", "pagination", "search"

    if(USERSTUDY_MODE){
        let callback = () => {};
        let timestamp = get_current_timestamp();
        let userjson = {
            "event": event,
            "target_info": target_info,
            "additional_info": additional_info,
            "timestamp": timestamp
        }
        console.log("userjson", userjson);
        let userid = USERID;
        let username = USERNAME;
        saveUserData(userid, username, userjson, callback);
    }

}

export default {
    dataServerUrl,
    intialize, 
    editModelQA,
    // queryPattern,
    choicesOneHops,  
    searchPattern, 
    subgroupCluster, 
    runModelQA,
    saveUserData,
    saveUserDataWrapper,
    updateUserInfo
}